// ToolFileNameContainer.jsx
import { useEffect } from 'react';

const ToolFileNameContainer = ({ fileName, setFileName }) => {
    useEffect(() => {
        console.log(`ToolFileNameContainer rendered. Current fileName: ${fileName}`);
    }, [fileName]);

    const handleFileNameChange = (e) => {
        const newValue = e.target.value;

        // Only update if the input value is different
        if (fileName !== newValue) {
            setFileName(newValue);
        }
    };

    return (
        <div id="fileNameContainer">
            <input
                id="fileNameInput"
                className="form-control draft-namer-input"
                type="text"
                value={fileName || ''}
                onChange={handleFileNameChange}
            />
        </div>
    );
};

export default ToolFileNameContainer;

